import { Hero } from '../components/Hero';
import { Footer } from '../components/Footer';
import { Header } from '../components/Header';
import { Roadmap } from '../components/Roadmap';
import { FinalCta } from '../components/FinalCta';
import { ValueProps } from '../components/ValueProps';
import { ProblemBand } from '../components/ProblemBand';
import { SecurityBand } from '../components/SecurityBand';
import { FeatureCards } from '../components/FeatureCards';
import { FilingSection } from '../components/FilingSection';
import { ScribeSection } from '../components/ScribeSection';
import { LandingStyles } from '../components/LandingStyles';
import { useScrollReveal } from '../hooks/use-landing-motion';
import { EngagementVerbs } from '../components/EngagementVerbs';
import { AnnouncementBar } from '../components/AnnouncementBar';
import { AudienceSection } from '../components/AudienceSection';

/**
 * `overflow-x-clip`, not `overflow-x-hidden`. Per CSS Overflow, when one axis
 * is not `visible` the other computes `visible` to `auto` — so `hidden` made
 * this element a scroll container in both axes, and every `sticky` descendant
 * resolved against a container that never scrolls. The header is `sticky`.
 * `clip` does not create a scroll container.
 *
 * Every block is mounted eagerly. `useScrollReveal` queries `[data-reveal]`
 * once on mount, so anything rendered later would never be observed and would
 * sit at `opacity: 0` permanently.
 *
 * The pricing section from the source design is deliberately absent: it ships
 * literal `[PRICE]` placeholders, which read as unfinished on a public site.
 */
export function LandingPage() {
  useScrollReveal();

  return (
    <>
      <LandingStyles />

      <div className="mn-landing relative w-full overflow-x-clip bg-background text-foreground">
        <AnnouncementBar />
        <Header />

        <main>
          <Hero />
          <ValueProps />
          <ProblemBand />
          <AudienceSection />
          <FeatureCards />
          <EngagementVerbs />
          <ScribeSection />
          <FilingSection />
          <Roadmap />
          <SecurityBand />
          <FinalCta />
        </main>

        <Footer />
      </div>
    </>
  );
}
